// eslint-disable-next-line
import React, { useEffect, useState } from "react";
import Layout from "../common/Layout";
import DynamicTitle from "../common/DynamicTitle";
import styled from "styled-components";
import MyButton from "../../landingPage/MyButton";
import TableContainer from "../common/TableContainer";
import ActionDropdown from "../common/ActionDropdown";
import FormModal from "../form/FormModal";
import useDialog from "../../../utils/useDialog";
import ProtectedComponents from "../local-routes/ProtectedComponents";
import { deleteFramework } from "../../../services/framework/api";
import { useFetchedFrameworkList } from "../../../services/framework/query";
import AddNewFramework from "../form/AddFramework";

const FrameworkPage = ({ pageType }) => {
  const { deleteItemDialog } = useDialog();

  const {
    data: frameworkList,
    refetch,
    isLoading,
  } = useFetchedFrameworkList();

  const [frameworkId, setFrameworkId] = useState(null);
  const [frameworkName, setFrameworkName] = useState(null);

  const [addFrameworkModal, setAddFrameworkModal] = useState(false);

  const [activeEditModal, setActiveEditModal] = useState(false);

  const showAddFramework = (e) => {
    setAddFrameworkModal(!addFrameworkModal);
  };
  const showEditFramework = (e) => {
    setActiveEditModal(!activeEditModal);
  };

  const handleDelete = (id, name) => {
    deleteItemDialog(deleteFramework, id, name, refetch);
  };

  return (
    <Layout pageLoading={isLoading} navType="admin">
      <DynamicTitle title="Framework Page | Fellowship Product" />

      <FrameworkLayout>
        <div className="framework-header">
          <h1>Framework</h1>
          <ProtectedComponents permission={["manageFrameworkSetup"]}>
            <MyButton
              onClick={() => setAddFrameworkModal(true)}
              className="btn-doc"
            >
              Create Framework
            </MyButton>
          </ProtectedComponents>
        </div>
        {
          <TableContainer>
            <table style={{ width: "100%" }}>
              <thead style={{ width: "100%" }}>
                <tr>
                  <th>Id</th>
                  <th>Name</th>
                  <ProtectedComponents permission={["manageFrameworkSetup"]}>
                    <th>Action</th>
                  </ProtectedComponents>
                </tr>
              </thead>
              <tbody style={{ width: "100%" }}>
                {frameworkList?.map(
                  ({ id, name }, index) => (
                    <tr className="" key={index + 1}>
                      <td>{id}</td>
                      <td>{name}</td>
                      <ProtectedComponents permission={["manageFrameworkSetup"]}>
                        <td>
                          <ActionDropdown>
                            <p
                              onClick={() => {
                                setActiveEditModal(true);
                                setFrameworkId(id);
                                setFrameworkName(name);
                              }}
                            >
                              {" "}
                              Edit{" "}
                            </p>

                            <p
                              onClick={() => {
                                handleDelete(id, name, "Admin");
                              }}
                            >
                              {" "}
                              Delete{" "}
                            </p>
                          </ActionDropdown>
                        </td>
                      </ProtectedComponents>
                    </tr>
                  )
                )}
                {frameworkList?.length === 0 && (
                  <tr>
                    <td colSpan="6" className="no-data">
                      No Data Available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </TableContainer>
        }

        {addFrameworkModal && (
          <div className="form-modal">
            <FormModal className="form" handleModal={showAddFramework}>
              {
                <AddNewFramework
                  closeModal={showAddFramework}
                  reload={refetch}
                />
              }
            </FormModal>
          </div>
        )}
        {activeEditModal && (
          <div className="form-modal">
            <FormModal className="form" handleModal={showEditFramework}>
              {
                <AddNewFramework
                  closeModal={showEditFramework}
                  isEditing
                  reload={refetch}
                  frameworkId={frameworkId}
                  frameworkName={frameworkName}
                />
              }
            </FormModal>
          </div>
        )}
      </FrameworkLayout>
    </Layout>
  );
};

const FrameworkLayout = styled.div`
  .framework-header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 4.8rem;
    margin-bottom: 1.1rem;
  }
  .framework-header h1 {
    font-weight: 700;
    font-size: 2.4rem;
  }
  .form-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
  }
`;

export default FrameworkPage;
